export const clientReminderGuideline = ({ intl }) => [
  {
    target: '.client-dashboard-number-div',
    content: 'jr-cr-1',
    placement: 'auto',
    disableBeacon: true,
    isFixed: true,
    disableScrolling: true,
    title: intl.formatMessage({ id: 'jr-cr-1-title' }),
    tutorialItemId: 'c42'
  }
];
